module.exports = __webpack_public_path__ + "static/media/sample_mll_rake_destination_yard_vins_new.05cdea06.csv";